import { render, staticRenderFns } from "./AddReview.vue?vue&type=template&id=15d35848&scoped=true&"
import script from "./AddReview.vue?vue&type=script&lang=js&"
export * from "./AddReview.vue?vue&type=script&lang=js&"
import style0 from "./AddReview.vue?vue&type=style&index=0&id=15d35848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d35848",
  null
  
)

export default component.exports